import { signOut } from "aws-amplify/auth";
import { authBus } from "../AuthEvents";

// this protects against multiple concurrent logout calls .. which can happen in gatsby as its naivagting pages
let logoutPromise: Promise<void> | null = null;

export const logout = async (): Promise<void> => {
  if (logoutPromise) {
    return logoutPromise;
  }

  logoutPromise = (async () => {
    try {
      await signOut();

      authBus.emitMessage("You have been signed out.", "success");
      authBus.emitTransition("loggedout");
    } finally {
      logoutPromise = null;
    }
  })();

  return logoutPromise;
};
